import React, { useEffect, useState } from "react";
import TicketWhite from '../assets/images/ticket-white.webp';
import TicketBlack from '../assets/images/ticket-black.webp';
import { NavLink, useNavigate } from "react-router-dom";

const Logo = `${process.env.PUBLIC_URL}/${encodeURIComponent("TNDS 2026 Logo White.png")}`;

const Navbar = () => {
    const navigate = useNavigate();

    const [navColor, setnavColor] = useState("transparent");
    const [navBorder, setnavBorder] = useState("transparent");
    const listenScrollEvent = () => {
      window.scrollY > 10 ? setnavColor("rgb(7 29 167 / 44%)") : setnavColor("transparent");
      window.scrollY > 10 ? setnavBorder("#c7c7c7b8") : setnavColor("transparent");
    };
    useEffect(() => {
      window.addEventListener("scroll", listenScrollEvent);
      return () => {
        window.removeEventListener("scroll", listenScrollEvent);
      };
    }, []);

  return (
    <div>
      <nav style={{
          backgroundColor: navColor,
          transition: "all 1s",
          backdropFilter:navColor === "transparent" ? "blur(0px)" : "blur(5px)",
        }} className="navbar navbar-expand-lg navbar-dark">
        <div style={{borderBottom: navBorder === "transparent" ? `1px solid #c7c7c7b8` : " 1px solid transparent"}} className="container nav-container">
          <NavLink className="navbar-brand" to="/Ticket">
            <img className="header-logo" src={Logo} alt="" />
          </NavLink>
          <div className="nav-btn-container ms-auto">
            <button onClick={()=>navigate('/Ticket')} className="btn nav-btn" >
                  <div className="figure">
                      <img className="ticket-black" src={TicketWhite} alt="" />
                      <img className="ticket-white" src={TicketBlack} alt="" />
                  </div>
                  <span>Buy Tickets</span>
            </button>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
